import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm';
import PhotoSwipe from 'photoswipe/dist/umd/photoswipe.umd.min';
import YoutubePlayer from "../youtube-player";
class TimelineSelectorsMixin {
    get selectorName() {
        return {
            node: 'timeline',
            card: {
                node: 'timeline-card',
                active: 'timeline-card--is-active'
            }
        }
    }
}
export default class Timeline extends TimelineSelectorsMixin {
    static init() {
        Array.prototype.forEach.call(document.querySelectorAll('.timeline'), el => {
            new Timeline(el);
        });
    }

    constructor(element) {
        if (!element) return;
        super();

        const cardNodes = Array.from(element.querySelectorAll('.' + super.selectorName.card.node));
        cardNodes.forEach(el => new TimelineCard(el));
    }
}

class TimelineCard extends TimelineSelectorsMixin {
    elementNode = null;

    constructor(element) {
        if (!element) return;
        super();

        this.elementNode = element;
        const lightbox = new PhotoSwipeLightbox({
            gallery: this.elementNode.querySelector('.pswp-gallery'),
            children: 'a',
            pswpModule: PhotoSwipe
        });

        lightbox.on('contentLoad', (e) => {
            const { content } = e;
            if (content.type === 'youtube-player') {
                e.preventDefault();

                // Create a container for iframe
                // and assign it to the `content.element` property
                content.element = document.createElement('div');
                content.element.className = 'pswp__youtube-player-container';

                const playerNode = this.elementNode.querySelector('.youtube-player').cloneNode(true);
                content.element.appendChild(playerNode);
                const newPlayer = content.element.querySelector('.youtube-player');
                new YoutubePlayer(newPlayer);
            }
        });

        lightbox.init();

        const isNeosBackend = document.body.classList.contains('neos-backend');
        if (isNeosBackend) {
            this.activate();
            return;
        }
        window.addEventListener('scroll', () => this.onScroll());
        this.onScroll();
    }

    onScroll() {
        this[this.inViewport(this.elementNode) ? 'activate' : 'deactivate']();
    }

    activate() {
        this.elementNode.classList.add(super.selectorName.card.active);
    }

    deactivate() {
        this.elementNode.classList.remove(super.selectorName.card.active);
    }

    inViewport(el) {
        let rect = el.getBoundingClientRect();

        return (
            rect.top + rect.height / 3 >= 0 &&
            rect.left + rect.width / 3 >= 0 &&
            (rect.bottom - rect.height / 3) <= (window.innerHeight || document.documentElement.clientHeight) &&
            (rect.right - rect.width / 3) <= (window.innerWidth || document.documentElement.clientWidth)
        );
    }
}
